export const channelOptions = [
  {
    text: 'TikTok',
    textCn: 'TikTok',
    value: 'tiktok',
  },
  {
    text: 'Youtube',
    textCn: 'Youtube',
    value: 'youtube',
  },
];
